export class DisciplineListModel {
    public id: number;
    public name: string;
}